import { render, staticRenderFns } from "./DatasetList.vue?vue&type=template&id=6d0e4a33"
import script from "./DatasetList.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetList.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports